'use strict';

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseResizableDirectiveController=require('../../../../../../dist-es6/client/angularCommon/baseResizableDirectiveController');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');

const YAxisWidth=70;
const YAxisLabelLeftMargin=5;

const XAxisHeight=50;
const XAxisTopMargin=10;
const XAxisLabelHeight=15;
const XAxisLabelBottomMargin=15;

const RightMargin=10;

const PixelsBetweenRows=5;
const PixelsBetweenColumns=5;

const MinAllowedBoxHeight=30;let

HistogramPlotterDirective=class HistogramPlotterDirective extends BaseControllerBackedDirective{
get objectBindings(){
return['group'];
}

get controller(){
return HistogramPlotterDirectiveController;
}};let


HistogramPlotterDirectiveController=class HistogramPlotterDirectiveController extends BaseResizableDirectiveController{
static get $inject(){
return['$scope','$element','$window'];
}

constructor($scope,$element,$window){
super($scope,$element,$window);

this._svgElement=null;

$scope.$watch('controller.group',(newGroup,oldGroup)=>{
if(_.exists(this.group)){
this._redraw();
}
});
}

_onDimensionsChanged(newDimensions,oldDimensions){
this._redraw();
}

get _binSize(){
return this.group.fatigueDistribution.binSize;
}

get _firstBinStart(){
return this.group.fatigueDistribution.start;
}

get _totalBins(){
return this.group.fatigueDistribution.bins.length;
}

_redraw(){
if(_.exists(this._svgElement)){
angular.element(this._svgElement).remove();
}

if(!this._dimensionsValid||!_.exists(this.group)){
return;
}

this._$element.append(`<svg width="${this.dimensions.width}" height="${this.dimensions.height}"></svg>`);
this._svgElement=this._$element[0].getElementsByTagName('svg')[0];

let numDisplayedRows=Math.max(1,...this.group.fatigueDistribution.bins.map(bin=>bin.length));
let plottableWidth=this.dimensions.width-YAxisWidth-RightMargin;

let xScale=d3.scale.linear().
domain([this._firstBinStart-.5*this._binSize,this._firstBinStart+(this._totalBins-.5)*this._binSize]).
range([0,plottableWidth]);

let yScale=d3.scale.linear().
domain([.5,numDisplayedRows+.5]).
range([this.dimensions.height-(XAxisHeight+XAxisTopMargin+XAxisLabelBottomMargin),0]);

let xAxis=d3.svg.axis().scale(xScale).orient('bottom').ticks(this._totalBins);
let yAxis=d3.svg.axis().scale(yScale).orient('left').ticks(Math.min(10,numDisplayedRows));

let svgContainer=d3.select(this._svgElement);

svgContainer.append('g').
attr({
class:'x-axis',
transform:`translate(${YAxisWidth}, ${this.dimensions.height-(XAxisHeight+XAxisTopMargin+XAxisLabelBottomMargin)})`}).
call(xAxis);
let ticks=svgContainer.append('g').attr({class:'y-axis',transform:`translate(${YAxisWidth}, 0)`}).call(yAxis);
try{

let lastTick=_.last(ticks.selectAll('.tick')[0]);
let rawTransform=d3.select(lastTick).attr('transform');

let yTransform=parseFloat(rawTransform.split('translate(0')[1].slice(1).split(')')[0]);
if(yTransform<15){
d3.select(lastTick).attr('visibility','hidden');
}
}catch(e){

}

svgContainer.append('text').
attr({
class:'axis-label',
transform:'rotate(-90)',
y:YAxisLabelLeftMargin,
x:-((this.dimensions.height-(XAxisTopMargin+XAxisLabelBottomMargin+XAxisLabelHeight))/2),
dy:'1em',
"text-anchor":'middle'}).

text('# Days');

svgContainer.append('text').
attr({
class:'axis-label',
x:YAxisWidth+plottableWidth/2,
y:this.dimensions.height-(XAxisTopMargin+XAxisLabelBottomMargin+XAxisLabelHeight),
dy:'1em',
"text-anchor":'middle'}).

text('Fatigue');

let widthOfOneBinOnScreen=xScale(1)-xScale(0);
let heightOfOneCountOnScreen=yScale(0)-yScale(1);
let drawIndividualBoxes=heightOfOneCountOnScreen>=MinAllowedBoxHeight;
if(!drawIndividualBoxes){
var getYandHeightForCombinedRows=count=>({
y:yScale(count+.5),
height:heightOfOneCountOnScreen*count});

}

if(drawIndividualBoxes){
for(let rowIndex=0;rowIndex<numDisplayedRows;rowIndex++){
svgContainer.append('rect').
attr({
class:'backdrop',
x:YAxisWidth,
y:yScale(rowIndex+1.5)+PixelsBetweenRows,
width:plottableWidth,
height:heightOfOneCountOnScreen-PixelsBetweenRows});

}
}else{
let{y,height}=getYandHeightForCombinedRows(numDisplayedRows);
svgContainer.append('rect').
attr({
class:'backdrop',
x:YAxisWidth,
y:y,
width:plottableWidth,
height:height});

}

this.group.fatigueDistribution.bins.forEach((bin,binIndex)=>{
let binValue=this._firstBinStart+binIndex*this._binSize;
let xPosition=YAxisWidth+xScale(binValue-0.5*this._binSize)+PixelsBetweenColumns;

let binThresholdStatus=ThresholdStatus.fromScoreAndThreshold(binValue,this.group.fatigueThreshold);
let itemRectClass='nominal';
switch(binThresholdStatus){
case ThresholdStatus.Above:
itemRectClass='alert';
break;
case ThresholdStatus.At:
itemRectClass='warn';
break;}


let width=widthOfOneBinOnScreen-PixelsBetweenColumns;

if(width<=0){
return;
}

if(drawIndividualBoxes){
bin.forEach((item,itemIndex)=>{
let height=heightOfOneCountOnScreen-PixelsBetweenRows;

if(height<=0){
return;
}

svgContainer.append('rect').
attr({
class:itemRectClass,
x:xPosition,
y:yScale(itemIndex+1.5)+PixelsBetweenRows,
width:width,
height:height});

});
}else if(bin.length>0){
let{y,height}=getYandHeightForCombinedRows(bin.length);

if(height<=0){
return;
}

svgContainer.append('rect').
attr({
class:itemRectClass,
x:xPosition,
y:y,
width:width,
height:height});

}
});
}};


module.exports=HistogramPlotterDirective;
//# sourceMappingURL=histogramPlotterDirective.js.map
